import React from 'react';
import { useTranslation } from "react-i18next";

const SliderModal = ({ showSlider, opacity, handleOpacityChange, closeModal }) => {
  const { t } = useTranslation();
  if (!showSlider) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        zIndex: 1000,
      
      }}
      onClick={closeModal}
    >
      <div
        style={{
          position: 'relative',
          background: '#FFF',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          padding: '15px',
          borderRadius: '10px',
          width: '200px',
          textAlign: 'center',
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={opacity}
          onChange={handleOpacityChange}
          style={{ width: '100%' }}
        />
        <p style={{ fontSize: '14px', textAlign: 'center', margin: '10px 0 0',  color: 'black' }}>
          {t("Opacity")}: {Math.round(opacity * 100)}%
        </p>
        <button
          onClick={closeModal}
          style={{
            marginTop: '10px',
            padding: '5px 10px',
            fontSize: '12px',
            borderRadius: '5px',
            border: 'none',
            backgroundColor: '#007BFF',
            color: '#FFF',
            cursor: 'pointer',
          }}
        >
         {t("Close")} 
        </button>
      </div>
    </div>
  );
};

export default SliderModal;
